import React, { useEffect, useState } from 'react';
import strings from "../../../locales/ro.json";
import { width } from '@fortawesome/free-solid-svg-icons/fa0';
import { text } from '@fortawesome/fontawesome-svg-core';
// import styles from './dropdown.module.css';

const Dropdown = ({ options, onSelect, isInitialGAV }) => {
  const [selectedValue, setSelectedValue] = useState('');

  const handleSelect = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    onSelect(value);
  };

  useEffect(() => {
    if(selectedValue === '' && isInitialGAV)
    {
      setSelectedValue('GAV')
      onSelect('GAV')
    }
  },[])

  const dropdownStyle = {
    width: '49%',
    marginTop: '20px',
    padding: '10px 15px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '16px',
    fontFamily: 'Arial, sans-serif',
    outline: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    allingItems: 'center',
  };

  const dropdownFocusStyle = {
    ...dropdownStyle,
  }

  const [isFocused, setIsFocused] = useState(false);

  return (
    <select 
      value={selectedValue}
      onChange={handleSelect}
      style={isFocused ? dropdownFocusStyle : dropdownStyle}
    >
      <option value="" disabled>
        {strings.createVote.selectGroup}
      </option>
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Dropdown;
